export const PaymentReportModes = {
  Month: 'month',
  Week: 'week',
}
